import React, { useState, ChangeEvent, FormEvent, useRef } from 'react';
import AuthProvider from "../services/auth/AuthProvider/Index";
import notifications from '../services/notifications';
import CenteredLoader from './CenteredLoader';

const CsvUploadForm: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [successes, setSuccesses] = useState<string[]>([]);
  const [failures, setFailures] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFile(event.target.files[0]);
    }
  };

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/v1/private/semen-analysis-kits/upload-csv`;
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${await AuthProvider.getValidAuthorizationToken()}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = await response.json();
      setLoading(false);
      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setSuccesses(result.data.successes);
      setFailures(result.data.failures);

      if (result.data.failures.length > 0) {
        notifications.error({
          message: "Completed with errors.",
        }) 
      } else {
        notifications.success({
          message: "Completed without errors.",
        }) 
      }

    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <input 
          type="file" 
          ref={fileInputRef}
          onChange={handleFileChange} 
          accept=".csv" />
        <button 
        className="px-12 py-2.5 font-medium text-center text-white bg-brand-blue-400 hover:bg-brand-blue-500 disabled:cursor-not-allowed disabled:opacity-75 block w-full mb-4 md:float-right md:w-auto md:ml-4 md:mb-0" 
        type="submit"
        disabled={!file}
        >Upload CSV</button>
      </form>
      {loading ? (
        <CenteredLoader className="flex mt-12 mb-12"/>
      ) : (
        <div>
          {/* Rest of your content */}
        </div>
      )}
      {successes.length > 0 && (
        <div className="border-4 border-green-600 my-3">
          <h3>Details Updated for kits with these IDs:</h3>
          <ul className="list-disc ml-6">
            {successes?.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      )}
      {failures.length > 0 && (
        <div className="border-4 border-red-600">
          <h3>System was unable to find matches for these IDs:</h3>
          <ul className="list-disc ml-6">
            {failures?.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default CsvUploadForm;

